import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export interface RTLState {
  isRTL: boolean;
}
const userLocale =
  navigator.languages?.length > 0 ? navigator.languages[0] : navigator.language;
const direction: any = new Intl.Locale(userLocale);
const dir = direction?.textInfo?.direction;
document.dir = dir;
document.body.setAttribute("dir", dir);
const initialState: RTLState = {
  isRTL: dir === "rtl",
};

export const RTLSlice = createSlice({
  name: "isRTL",
  initialState,
  reducers: {
    setIsRTL: (state, action: PayloadAction<any>) => {
      state.isRTL = action.payload;
    },
  },
});

export const { setIsRTL } = RTLSlice.actions;

export const selectIsRTL = (state: RootState) => state.isRTL;

export default RTLSlice.reducer;
